// src/utils/roleLabels.js
// Etiqueta visible del rol. El valor interno ('soporte', 'admin', etc.) no
// cambia -- sigue siendo el que usan los permisos, guards y la BD. Esto solo
// controla cómo se muestra en pantalla (ej. 'soporte' se ve como 'Staff').
const ROLE_LABELS = {
  admin: 'Admin',
  soporte: 'Staff',
  sap: 'SAP',
  usuario: 'Usuario',
};

export function getRoleLabel(role) {
  if (!role) return 'Usuario';
  return ROLE_LABELS[role.toLowerCase()] || role;
}
